import {secretApi} from "../../api/api";

const sll_tournament = async ({tournamentName, groupArray = ['A', 'B', 'FINALS']}) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_tournament`);
        url.searchParams.set('tournament', tournamentName)

        const result = await secretApi.get(url.toString());
        const data = result.data.tournament_data

        const groupA = data[groupArray[0]] ? tournamentMapData(Object.values(data[groupArray[0]])) : []
        const groupB = data[groupArray[1]] ? tournamentMapData(Object.values(data[groupArray[1]])) : []
        const finals = data[groupArray[2]] ? tournamentMapData(Object.values(data[groupArray[2]])) : []


        return {
            A: groupA,
            B: groupB,
            FINALS: finals
        }
    } catch (e) {
        console.log(e)
        return {A: [], B: [], FINALS: []}
    }
}

export const sll_tournament2 = async({tournamentName}) =>
{
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_tournament`);
        url.searchParams.set('tournament', tournamentName)


        const result = await secretApi.get(url.toString());
        const data = result.data.tournament_data

        const group = data.Group_stage ? Object.values(data.Group_stage) : []
        const finals = data.FINALS ? tournamentMapData(Object.values(data.FINALS)) : []


        return {
            GROUP: group,
            FINALS: finals
        }
    } catch (e) {
        console.log(e)
        return {GROUP: [], FINALS: []}
    }
}


export const sll_tournament3 = async({tournamentName}) =>
{
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_tournament`);
        url.searchParams.set('tournament', tournamentName)


        const result = await secretApi.get(url.toString());
        const data = tournamentMapData(Object.values(result.data.tournament_data.B));

        return {
            FINALS: data
        }
    } catch (e) {
        console.log(e)
        return { FINALS: []}
    }
}


const tournamentMapData = (mapData) => {
    if (!mapData) {
        return []
    }
    const map = mapData.map((data) => {
        return data.map((item) => {
            const entreis = Object.entries(item)
            return {
                team: entreis[0][0] === '???' ? '????' : entreis[0][0],
                isWin: entreis[0][1]
            }
        })
    });
    return map
}

export default sll_tournament